import { render } from "./PlayerVoteCounter.vue?vue&type=template&id=c5bd91fc&scoped=true"
import script from "./PlayerVoteCounter.vue?vue&type=script&lang=js"
export * from "./PlayerVoteCounter.vue?vue&type=script&lang=js"

import "./PlayerVoteCounter.vue?vue&type=style&index=0&id=c5bd91fc&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5bd91fc"]])

export default __exports__